import { useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { formatMaintenanceStart } from '@/lib/systemMaintenance';

const BANNER_HEIGHT_CSS_VAR = '--system-maintenance-banner-height';

const SystemMaintenanceBanner = () => {
    const ref = useRef(null);
    const { locale } = useIntl();

    useEffect(() => {
        if (ref.current) {
            document.documentElement.style.setProperty(BANNER_HEIGHT_CSS_VAR, `${ref.current.offsetHeight}px`);
        }
        return () => {
            document.documentElement.style.removeProperty(BANNER_HEIGHT_CSS_VAR);
        };
    }, []);

    return (
        <div
            ref={ref}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                backgroundColor: '#f90',
                color: '#fff',
                padding: 4,
                textAlign: 'center',
                zIndex: 1050,
            }}
        >
            <span className='uikit-icon icon-wrench padding-right-5' />
            <strong>
                <FormattedMessage id='intl-msg:systemMaintenance.banner.title' />
            </strong>
            {' ➔ '}
            <FormattedMessage
                id='intl-msg:systemMaintenance.banner.details'
                values={{ dt: formatMaintenanceStart(locale) }}
            />
            <span className='uikit-icon icon-wrench padding-left-5' />
        </div>
    );
};

export default SystemMaintenanceBanner;
